import { HStack, Image, Text, VStack, Icon, Heading, Button, AspectRatio } from '@chakra-ui/react';

import { IoIosCheckmarkCircle } from 'react-icons/io';
import { IoOpenOutline } from 'react-icons/io5';

import { RemotePickMealPointWithId } from '~/types/platform/remotePickMealPoint';

import { useNavigate } from 'react-router-dom';

import tzuchiDefaultImg from '~/assets/images/defaultImage.png';

type LocationItemProps = {
  isActive?: boolean;
  pointData: RemotePickMealPointWithId;
  onClick?: () => void;
  onClose?: () => void;
};

export default function LocationItem({
  isActive = false,
  pointData,
  onClick,
  onClose,
}: LocationItemProps) {
  const navigate = useNavigate();

  const { id, name, image, description } = pointData;

  return (
    <HStack
      p={2}
      align="flex-start"
      cursor="pointer"
      justify="space-between"
      spacing={4}
      borderWidth="1px"
      borderColor={isActive ? 'primary' : 'gray.400'}
      borderRadius="5px"
      _hover={{
        borderColor: 'primary',
      }}
      onClick={onClick}
    >
      <HStack p={2} spacing={4}>
        <AspectRatio ratio={1 / 1} borderRadius="full" w="4rem">
          <Image src={image ? image : tzuchiDefaultImg} borderRadius="full" objectFit="contain" />
        </AspectRatio>
        <VStack align="flex-start" spacing={2} flex="1">
          <Heading size="xs">{name}</Heading>
          <Text fontSize="xs" textAlign="left">
            {description}
          </Text>

          <Button
            as="a"
            variant="link"
            letterSpacing="0.1em"
            size="xs"
            color="primary"
            rightIcon={<Icon as={IoOpenOutline} boxSize="1rem" color="primary" />}
            onClick={(e) => {
              e.stopPropagation();
              onClose?.();
              navigate(`/pickMealLocationInfo/${id}`);
            }}
          >
            查看取餐地點
          </Button>
        </VStack>
      </HStack>
      <Icon
        as={IoIosCheckmarkCircle}
        color={isActive ? 'primary' : 'gray.300'}
        boxSize="1.875rem"
      />
    </HStack>
  );
}
